import React, { useState } from 'react'
import styled from 'styled-components'
import { Button } from '@streamr/streamr-layout'
import { TABLET, DESKTOP } from '@streamr/streamr-layout/styled'
import Slide1st from './assets/Slide1st'
import Slide2nd from './assets/Slide2nd'
import Slide3rd from './assets/Slide3rd'
import Gallery, { slideIndex } from '~shared/Gallery'
import Topic from '~shared/Topic'
import CaseStudy from '~shared/CaseStudy'
import ButtonWrapper from '~shared/ButtonWrapper'
import Container from '~shared/Container'
import useTranslation from '~utils/useTranslation'
import Link from '~shared/Link'
import urls from '~utils/urls'

const Inner = styled.div`
    margin: 0 auto;

    @media (min-width: ${TABLET}px) {
        max-width: 536px;
    }

    @media (min-width: ${DESKTOP}px) {
        max-width: 908px;
    }
`

const UnstyledSwashGallery = (props) => {
    const [slide, setSlide] = useState(0)

    const index = slideIndex(slide, 3)

    const { t } = useTranslation()

    return (
        <div {...props}>
            <Container>
                <Inner>
                    <Gallery.Item as="div">
                        <Slide1st />
                    </Gallery.Item>
                    <Gallery slide={slide} onChange={setSlide} arrowColor="blue">
                        <Gallery.Item as="div" disabled={index !== 0}>
                            <Slide1st />
                        </Gallery.Item>
                        <Gallery.Item as="div" disabled={index !== 1}>
                            <Slide2nd />
                        </Gallery.Item>
                        <Gallery.Item as="div" disabled={index !== 2}>
                            <Slide3rd />
                        </Gallery.Item>
                    </Gallery>
                    <Gallery.SlideContainer>
                        <CaseStudy active name="Case Study — Swash">
                            <Topic.Paragraph $appear>
                                A browser extension called Swash has become the world&apos;s
                                first digital Data Union. Introduced at Mozfest in&nbsp;London
                                in October 2019, Swash allows users to capture their browsing
                                data, and then sell it in real-time&nbsp;via a Data Union on the
                                data Marketplace, with one&#8209;to&#8209;many micropayments.
                            </Topic.Paragraph>
                            <ButtonWrapper>
                                <Button
                                    tag={Link}
                                    to={urls.caseStudies.swash}
                                    kind="primary"
                                    size="big"
                                    outline
                                    noDecoration
                                    noHover
                                >
                                    {t('caseStudy.readMoreAbout', {
                                        study: 'Swash',
                                    })}
                                </Button>
                            </ButtonWrapper>
                        </CaseStudy>
                    </Gallery.SlideContainer>
                </Inner>
            </Container>

        </div>
    )
}

const SwashGallery = styled(UnstyledSwashGallery)`
    ${Gallery} {
        display: none;
    }

    ${Gallery.Item} {
        border-radius: 2px;
        overflow: hidden;

        img {
            border-radius: 2px;
        }
    }
    
    ${Inner} > ${Gallery.Item} {
        margin-bottom: 40px;
    }

    ${Button} {
        margin-top: 30px;
    }

    @media (min-width: ${TABLET}px) {
        ${Gallery} {
            display: block;
        }

        ${Gallery.Item} {
            box-shadow: 0px 0px 30px rgb(0 0 0 / 5%);
        }

        ${Inner} > ${Gallery.Item} {
            display: none;
        }

        ${Inner} > ${Gallery.SlideContainer} {
            margin-top: 70px;
        }

        ${Button} {
            margin-top: 40px;
        }
    }

    @media (min-width: ${DESKTOP}px) {
        ${Inner} > ${Gallery.SlideContainer} {
            margin-top: 100px;
        }
    }
`

export default SwashGallery
